import { useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

import "./index.css";

export default function App() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <BrowserRouter>

      {/* Top Contact Bar */}
      <div className="topbar">
        📞 <a href="tel:+919175002621">+91 91750 02621</a>
        &nbsp; | &nbsp;
        ✉ <a href="mailto:southernrewinds@gmail.com">southernrewinds@gmail.com</a>
      </div>

      {/* Header */}
      <header className="header">

        {/* Left: Logo + Company Name */}
        <div className="header-left">
          <img
            src="/assets/spsr-logo.png"
            alt="SPSR Logo"
            className="logo"
          />

          <div className="company-text">
            <h1>SOUTHERN</h1>
            <h2>POWERSYSTEM</h2>
            <h3>REWINDS PVT. LTD.</h3>
          </div>
        </div>

        {/* Hamburger Button */}
        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </div>

        {/* Navigation */}
        <nav className={`navbar ${menuOpen ? "open" : ""}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>ABOUT US</Link>
          <Link to="/services" onClick={() => setMenuOpen(false)}>OUR SERVICES</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US</Link>
        </nav>

      </header>

      {/* Pages */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

    </BrowserRouter>
  );
}
